import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import Select from "react-select";
import Card from "@material-ui/core/Card";
import ImageUpload from "../../../components/CustomUpload/ImageUpload.jsx";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { FormControl } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";

import toastr from "toastr";
import { hist } from "../../..";

import axios from "../../../config/axios";
import { getAllCategories$ } from "../../../redux/actions/category.js";
// import { getAllSpeakers$ } from "../../../redux/actions/speaker.js";

// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
// import moment from "moment";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw
} from "draft-js";
import draftToHtml from "draftjs-to-html";

toastr.options = {
  closeButton: true
};

const validationStyle = {
  color: "red"
};

const addButtonProps = {
  color: "rose",
  round: true
};
const changeButtonProps = {
  color: "rose",
  round: true
};
const removeButtonProps = {
  color: "danger",
  round: true
};
class AddNewsAndAnnouncements extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      newData: null,
      new_images: null,
      newTitle: null,
      categoryList: [],
      category_name: [],
      brief_desc: "",
      editorState: EditorState.createEmpty(),
      action: "Add"
    };
  }
  componentDidMount() {
    this.props.handleGetCategoryList();
    if (this.props.categoryListData) {
      let categoryList = [];
      this.props.categoryListData.data.map(category =>
        categoryList.push({ value: category.name, label: category.name })
      );
      this.setState({
        categoryList
      });
    }

    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.news
    ) {
      let newsDetails = this.props.location.state.news;
      const image =
        newsDetails.news_images.length > 0
          ? newsDetails.news_images[0].path
          : null;

      // for (let i = 0; i < event_category.length; i++) {
      //   category_name.push({
      //     value: event_category[i].name,
      //     label: event_category[i].name
      //   });
      this.setState({
        newTitle: newsDetails.news_title,
        brief_desc: newsDetails.brief_desc,
        editorState: EditorState.createWithContent(
          ContentState.createFromBlockArray(
            convertFromHTML(decodeURIComponent(newsDetails.complete_desc))
          )
        ),
        new_images: image,
        action: this.props.location.state.action,
        category_name: [
          { value: newsDetails.category, label: newsDetails.category }
        ]
      });
    }
  }
  fileUploadHandler = file => {
    let form = new FormData();
    form.append("image", file);
    axios
      .post("storage/news/upload-file", form)
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          this.setState({ new_images: res.data.data[0] });
        }
      })
      .catch(error => {
        toastr.error(error.response.data.message);
      });
  };

  uploadImageCallBack = file => {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("image", file);
      axios
        .post("storage/news/upload-file", form)
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            resolve({ data: { link: res.data.data[0] } });
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  submitForm = () => {
    let {
      newTitle,
      new_images,
      category_name,
      brief_desc,
      editorState,
      action
    } = this.state;

    const image = [{ path: new_images }];
    const editor = encodeURIComponent(
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    );
    const requestBody = {
      news_title: newTitle,
      category: category_name[0].value,
      brief_desc,
      complete_desc: editor,
      news_images: image
    };

    if (this.validator.allValid()) {
      if (action === "Add") {
        axios
          .post("news", requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("News Created Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => toastr.error(error.response.data.message));
      } else {
        axios
          .put(`news/${this.props.location.state.news.id}`, requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("News Updated Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => toastr.error(error.response.data.message));
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  inputHandler = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };
  render() {
    let {
      newTitle,
      new_images,
      categoryList,
      category_name,
      brief_desc,
      editorState,
      // action
    } = this.state;
    return (
      <div className="add-category-form">
        <Card
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          <CardContent>
            <form>
              <GridContainer>
                <GridItem md={12}>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="newTitle"
                    name="newTitle"
                    label="News Title*"
                    type="text"
                    fullWidth
                    value={newTitle}
                    onChange={event => {
                      this.inputHandler(event);
                    }}
                  />
                  {
                    <span style={validationStyle}>
                      {this.validator.message(
                        "News Title",
                        newTitle,
                        "required"
                      )}
                    </span>
                  }
                </GridItem>

                <GridItem
                  md={12}
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  style={{ marginTop: "20px" }}
                >
                  <legend>Banner Image</legend>
                  <ImageUpload
                    className="image_upload"
                    currentProduct={
                      new_images !== null
                        ? { image: new_images }
                        : { image: "" }
                    }
                    uploadImage={this.fileUploadHandler}
                    addButtonProps={addButtonProps}
                    changeButtonProps={changeButtonProps}
                    removeButtonProps={removeButtonProps}
                  />
                </GridItem>

                <GridItem md={12}>
                  <FormControl fullWidth style={{ margin: "0.7rem 0" }}>
                    <legend style={{ fontSize: "1rem" }}>Category</legend>
                    <Select
                      isMulti
                      name="category"
                      options={categoryList}
                      value={category_name}
                      onChange={(inputValue, actionMeta) => {
                        if (inputValue) {
                          this.setState({
                            category_name: inputValue
                          });
                        }
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </FormControl>
                  {
                    <span style={validationStyle}>
                      {this.validator.message(
                        "category_name",
                        category_name,
                        "required"
                      )}
                    </span>
                  }
                </GridItem>
                <GridItem className="brief_des" md={12}>
                  <TextField
                    InputLabelProps={{
                      shrink: brief_desc ? true : false
                    }}
                    margin="dense"
                    id="brief_desc"
                    name="brief_desc"
                    label="Brief Description*"
                    type="text"
                    multiline={true}
                    fullWidth
                    value={brief_desc}
                    onChange={event => {
                      this.inputHandler(event);
                    }}
                  />
                  {
                    <span style={validationStyle}>
                      {this.validator.message(
                        "brief_desc",
                        brief_desc,
                        "required"
                      )}
                    </span>
                  }
                </GridItem>

                <GridItem md={12}>
                  <InputLabel shrink={true}>Complete Description</InputLabel>
                  <Editor
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                    editorState={editorState}
                    toolbar={{
                      image: {
                        uploadCallback: this.uploadImageCallBack,
                        alt: { present: true, mandatory: true }
                      }
                    }}
                    onEditorStateChange={editorState =>
                      this.setState({ editorState })
                    }
                  />
                </GridItem>
              </GridContainer>
            </form>
          </CardContent>
          <CardActions style={{ float: "right" }}>
            <Button variant="contained" color="iseas" onClick={this.submitForm}>
              Submit
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    categoryListData: state.category
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetCategoryList: () => dispatch(getAllCategories$.trigger())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(extendedFormsStyle)(AddNewsAndAnnouncements));



// WEBPACK FOOTER //
// ./src/views/ISEAS/NewsAndAnnouncements/AddNewsAndAnnouncement.js